module.exports = __webpack_public_path__ + "img/e2b7346.png";